import api from "@/lib/api";

export const BTN = "rounded-full bg-[#065F46] hover:bg-[#047857]";

export async function downloadBlob(url, filename) {
  const r = await api.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}

export const DOC_CATS = {
  contrat: "Contrat de travail", avenant: "Avenant", fiche_poste: "Fiche de poste", piece_identite: "Pièce d'identité",
  titre_sejour: "Titre de séjour", rib: "RIB", diplome: "Diplôme", certification: "Certification", formation: "Attestation de formation",
  entretien: "Compte rendu d'entretien", avertissement: "Avertissement", mutuelle: "Mutuelle", prevoyance: "Prévoyance",
  certificat_medical: "Certificat médical", visite_medicale: "Visite médicale", autre: "Autre",
};
export const MEDICAL = ["certificat_medical", "visite_medicale"];

export const EVENT_TYPES = {
  embauche: "Embauche", avenant: "Avenant", changement_poste: "Changement de poste", promotion: "Promotion",
  entretien_annuel: "Entretien annuel", entretien_pro: "Entretien professionnel", avertissement: "Avertissement",
  sanction: "Sanction", felicitations: "Félicitations", sortie: "Sortie", autre: "Autre",
};

export const DEADLINE_TYPES = {
  visite_medicale: "Visite médicale", fin_periode_essai: "Fin de période d'essai", fin_cdd: "Fin de CDD",
  certification: "Certification", entretien_pro: "Entretien professionnel", titre_sejour: "Titre de séjour",
  formation: "Formation", autre: "Autre",
};

export const TRAINING_STATUS = { prevue: "Prévue", en_cours: "En cours", realisee: "Réalisée", annulee: "Annulée" };

export const urgency = (d) => {
  if (!d) return "ok";
  const [y, m, day] = String(d).slice(0, 10).split("-").map(Number);
  const t = new Date(); t.setHours(0, 0, 0, 0);
  const diff = Math.round((new Date(y, m - 1, day) - t) / 86400000);
  if (diff <= 7) return "urgent";
  if (diff <= 30) return "bientot";
  return "ok";
};
